import React from 'react';
import { useTranslation } from 'react-i18next';


import { makeStyles } from 'tss-react/mui';
import {
  MUIDataTableColumnDef,
  Pill,
  PillVariant,
  TABLE_INITIAL_STATE,
  useDataTable,
} from 'web-library';
import { ApplicationStatus, EntityModelList } from '../../../api/candidate/exam/model';
import DocumentBadge from '../../../components/DocumentBadge';

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles()((theme) =>
({
  marginTop1: {
    marginTop: theme.spacing(1),
  },
}));

export const useCoordinatorSummaryDataTable = (isView: boolean) => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const { state: tableState, dispatch: tableDispatch } = useDataTable({
    ...TABLE_INITIAL_STATE,
    size: 10,
  });

  const widths = isView
    ? ['15%', '20%', '15%', '15%', '15%', '15%']
    : ['15%', '35%', '15%', '15%', '15%'];

  const tableColumns: MUIDataTableColumnDef[] = [
    {
      name: 'candidateId',
      label: t('withdrawal->>Coordinator.Summary.Content.ID'),
      options: {
        setCellProps: (cellValue: any, rowIndex: number, columnIndex: number) => ({
          style: { width: widths[columnIndex] },
        }),
      },
    },
    {
      name: 'name',
      label: t('withdrawal->>Coordinator.Summary.Content.CandidateName'),
      options: {
        setCellProps: (cellValue: any, rowIndex: number, columnIndex: number) => ({
          style: { width: widths[columnIndex] },
        }),
      },
    },
    {
      name: 'examLevel',
      label: t('withdrawal->>Coordinator.Summary.Content.ExamLevel'),
      options: {
        setCellProps: (cellValue: any, rowIndex: number, columnIndex: number) => ({
          style: { width: widths[columnIndex] },
        }),
        customBodyRender: (value: any) => value.join(', '),
      },
    },
    {
      name: 'examSeries',
      label: t('withdrawal->>Coordinator.Summary.Content.ExamSeries'),
      options: {
        setCellProps: (cellValue: any, rowIndex: number, columnIndex: number) => ({
          style: { width: widths[columnIndex] },
        }),
        customBodyRender: (value: any) => value.join(', '),
      },
    },
    {
      name: 'documents',
      label: t('withdrawal->>Coordinator.Summary.Content.SupportingDocuments'),
      options: {
        setCellProps: (cellValue: any, rowIndex: number, columnIndex: number) => ({
          style: { width: widths[columnIndex] },
        }),
        customBodyRender: (value: any) =>
          value.map((item: EntityModelList, index: number) => (
            <DocumentBadge
              key={item.uuid}
              className={index !== 0 ? classes.marginTop1 : ''}
              documentName={item.fileName || 'N/A'}
            />
          )),
      },
    },
    {
      name: 'status',
      label: t('withdrawal->>Coordinator.Summary.View.Status'),
      options: {
        display: isView || 'excluded',
        setCellProps: (cellValue: any, rowIndex: number, columnIndex: number) => ({
          style: { width: widths[columnIndex] },
        }),
        customBodyRender: (value: any) => {
          let variant: PillVariant;

          switch (value) {
            case ApplicationStatus.PENDING_APPROVAL_WITHDRAW:
              variant = 'info';
              break;

            case ApplicationStatus.WITHDRAWN:
              variant = 'default';
              break;

            default:
              return null;
          }

          return <Pill variant={variant} label={value} />;
        },
      },
    },
  ];

  return { tableState, tableDispatch, tableColumns };
};

export const rowsPerPageOptionsDefault = [10, 20, 35, 50, 100];
